import axios from 'axios';

import { useVuelidate } from '@vuelidate/core';
import { required, numeric, between, helpers } from '@vuelidate/validators';

import { Chart as ChartJS, ArcElement, Tooltip, Legend, Title } from 'chart.js';
import { Pie } from 'vue-chartjs';

ChartJS.register(ArcElement, Tooltip, Legend, Title);

const diaperRiskWidgetApp = {
    setup() {
        return { v$: useVuelidate() }
    },
    components: {
        Pie,
    },
    data() {
        return {
            FP: 0,
            fpMin: 0,
            fpMax: 12,
            Age: 18,
            ageMin: 3,
            ageMax: 100,
            MUL: 12,
            mulMin: 0,
            mulMax: 100,
            ICIQ: 0,
            iciqMin: 0,
            iciqMax: 21,
            IPSS: 0,
            ipssMin: 0,
            ipssMax: 35,
            data: null,

            dataApi: '/umbraco/api/diaperrisk/calculate',
            dataChartTitle: '',
            error: false,
        }
    },
    validations() {
        return {
            FP: { required, numeric, betweenValue: between(this.fpMin, this.fpMax) },
            Age: { required, numeric, betweenValue: between(this.ageMin, this.ageMax) },
            MUL: { required, numeric, betweenValue: between(this.mulMin, this.mulMax) },
            ICIQ: { required, numeric, betweenValue: between(this.iciqMin, this.iciqMax) },
            IPSS: { required, numeric, betweenValue: between(this.ipssMin, this.ipssMax) },
        }
    },
    computed: {
        hasData() {
            return this.data && this.data.risks && this.data.risks.length;
        },
        dataset() {
            if (!this.hasData) return { labels: [], dataSets: [] };
            return {
                labels: this.data.risks.map(risk => risk.label),
                datasets: [{
                    data: this.data.risks.map(risk => risk.percentage),
                    backgroundColor: ['#00b050', '#92d050', '#ffff00', '#ffc000', '#ff0000'],
                }]
            }
        },
        options() {
            return {
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                    legend: {
                        position: 'right',
                        labels: {
                            boxWidth: 18,
                            font: {
                                size: 18,
                            },
                            padding: 12,
                        },
                    },
                    title: {
                        display: true,
                        text: this.dataChartTitle,
                        font: {
                            size: 22,
                        },
                        color: '#0a0a0a',
                    },
                    tooltip: {
                        callbacks: {
                            label: (context) => ` ${this.data.risks[context.dataIndex].percentageDisplay}%`,
                        },
                    }
                },
            }
        }
    },
    methods: {
        async submit() {
            this.error = false;
            const result = await this.v$.$validate();
            if (!result) return;
            try {
                const response = await axios.post('/umbraco/api/diaperrisk/calculate',
                    {
                        FP: this.FP,
                        Age: this.Age,
                        MUL: this.MUL,
                        ICIQ: this.ICIQ,
                        IPSS: this.IPSS,
                    }
                );
                if (!response || !response.data || !response.data.success) throw new Error('Failed to calculate diaper risk');
                this.data = response.data;
            }
            catch (error) {
                console.error(error);
                this.error = true;
            }
        }
    },
    mounted() {
        if (this.$el.dataset.api) this.dataApi = this.$el.dataset.api;
        if (this.$el.dataset.chartTitle) this.dataChartTitle = this.$el.dataset.chartTitle;

        if (this.$el.dataset.fpMin) this.fpMin = parseInt(this.$el.dataset.fpMin);
        if (this.$el.dataset.fpMax) this.fpMax = parseInt(this.$el.dataset.fpMax);
        if (this.$el.dataset.fpDefault) this.FP = parseInt(this.$el.dataset.fpDefault);
        if (this.$el.dataset.ageMin) this.ageMin = parseInt(this.$el.dataset.ageMin);
        if (this.$el.dataset.ageMax) this.ageMax = parseInt(this.$el.dataset.ageMax);
        if (this.$el.dataset.ageDefault) this.Age = parseInt(this.$el.dataset.ageDefault);
        if (this.$el.dataset.mulMin) this.mulMin = parseInt(this.$el.dataset.mulMin);
        if (this.$el.dataset.mulMax) this.mulMax = parseInt(this.$el.dataset.mulMax);
        if (this.$el.dataset.mulDefault) this.MUL = parseInt(this.$el.dataset.mulDefault);
        if (this.$el.dataset.iciqMin) this.iciqMin = parseInt(this.$el.dataset.iciqMin);
        if (this.$el.dataset.iciqMax) this.iciqMax = parseInt(this.$el.dataset.iciqMax);
        if (this.$el.dataset.iciqDefault) this.ICIQ = parseInt(this.$el.dataset.iciqDefault);
        if (this.$el.dataset.ipssMin) this.ipssMin = parseInt(this.$el.dataset.ipssMin);
        if (this.$el.dataset.ipssMax) this.ipssMax = parseInt(this.$el.dataset.ipssMax);
        if (this.$el.dataset.ipssDefault) this.IPSS = parseInt(this.$el.dataset.ipssDefault);
    }
};

export default diaperRiskWidgetApp;
